export default __webpack_public_path__ + "static/media/example-icon.ebaff565.svg";